export const closeButtonMessages = {
  en: {
    close: 'close'
  },
  fi: {
    close: 'sulje'
  },
  sv: {
    close: 'stäng'
  }
};
export const iconAriaLabelTexts = {
  // The ':' sign at the end of each text string is required for improving the reading rhythm of screen readers
  en: {
    positive: 'Confirmation: ',
    information: 'Information: ',
    notification: 'Note: ',
    warning: 'Warning: ',
    critical: 'Error: '
  },
  fi: {
    positive: 'Vahvistus: ',
    information: 'Tiedoksi: ',
    notification: 'Huomio: ',
    warning: 'Varoitus: ',
    critical: 'Virhe: '
  },
  sv: {
    positive: 'Bekräftelse: ',
    information: 'För kännedom: ',
    notification: 'Observera: ',
    warning: 'Varning: ',
    critical: 'Fel: '
  }
};